module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Åpne safen"},"en":{"title":"Unlock the safe"}}')
  delete Component.options._Ctor
}
